<template>
  <div>
    <el-form
      style="width:100%"
      :inline="true"
      :model="addDataData"
      ref="applyForm"
      :rules="rules"
      label-position="top"
    >
      <el-form-item label="角色" prop="bank" l>
        <el-select
          filterable
          style="width:100%"
          v-model="role_name"
          placeholder="請選擇角色"
        >
          <el-option
            :label="role.name"
            :value="role.name"
            v-for="role in roleList"
            :key="role.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="用戶ID">
        <el-input v-model="user_id" type="text" placeholder="用戶ID"></el-input>
      </el-form-item>
      <el-form-item label="內容" prop="amount" style="width:100%">
        <el-input
          v-model="msg"
          :rows="5"
          type="textarea"
          placeholder="內容"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="send()">送出</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
export default {
  data() {
    return {
      addDataData: {},
      msg: "",
      roleList: [],
      user_id: "",
      role_name: ""
    };
  },
  methods: {
    send() {
      let msg = JSON.parse(JSON.stringify(this.msg));
      msg = msg.replace(new RegExp(/\n/g), "</br>");
      let sendData = {
        user_id: this.user_id,
        msg,
        role_name: this.role_name
      };
      Object.keys(sendData).forEach(e => {
        if (!sendData[e]) {
          delete sendData[e];
        }
      });
      this.$http.post(`/back/admin/push_system_msg`, sendData).then(res => {
        if (res.data.code == 0) {
          this.$message.success("成功");
          this.user_id = "";
          this.msg = "";
          this.role_name = "";
        }
      });
    }
  },
  created() {
    this.$http.get(`/back/admin/roles`).then(res => {
      if (res.data.code == 0) {
        this.roleList = res.data.data;
      }
    });
  }
};
</script>
